import { message } from '@linktivity/link-ui';
import { auth } from '@link/admin/stores';

const BASE_PATH = import.meta.env.VITE_APP_ADMIN_API as string;

export interface ServiceConfigOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Configuration: any;
  basePath?: string;
}

export function createServiceConfig({
  Configuration,
  basePath = BASE_PATH
}: ServiceConfigOptions) {
  return new Configuration({
    basePath: basePath,
    middleware: [
      {
        pre: async (context: { init: RequestInit }) => {
          const requestHeaders: HeadersInit = new Headers({
            'Content-Type': 'application/json'
          });
          requestHeaders.append(
            'Authorization',
            'Bearer ' + (await auth.getRefreshedToken())
          );
          context.init.headers = requestHeaders;
        },
        post: async (context: { response: Response }) => {
          if (context.response.status === 401) {
            localStorage.clear();
            location.replace('/login');
          } else if (!context.response.ok) {
            // handle error
            const data = await context.response.json();

            // 当 message 为 "unknown error" 时，循环提取 details 的 reason 分别抛出
            if (data?.message === 'unknown error' && data?.details?.length) {
              data.details.forEach((detail: { reason?: string }) => {
                if (detail.reason) {
                  message.error(detail.reason, 10);
                }
              });
            } else {
              const errorMessage = data?.message || data?.details?.[0]?.reason;
              message.error(errorMessage, 10);
            }

            return data;
          }
        }
      }
    ]
  });
}
